import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchHistoricos(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('historicos', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    }
  },
}
